module.exports = "/images/chevron-down.svg?2d090f38d3a45ff4430408f7986e8ba8";